export default "__VITE_ASSET__fd6e5abf__"